import React from "react";
import { Img } from "../../../subComponents/img";
import { Heading } from "../../../subComponents/Heading";
import { NavLink } from "react-router-dom";
import { Skeleton, Grid } from "@mui/material";

const ProductCategoryHeroSection = ({
  title,
  content,
  subcategorylist,
  categoryslug,
  bannerImage,
}) => {
  return (
    <>
      <section className="upvc_hero_section">
        {/* {bannerImage === null ? (
          <Skeleton
            variant="rectangle"
            height={"100%"}
            width={"100%"}
          ></Skeleton>
        ) : (
          <>
          <Img src={bannerImage || "/assets/images/new_images/banners/blog_banner.jpg"} alt={"Banner.png"} />
          </>
        )} */}
         <Img src={bannerImage || "/assets/images/new_images/banners/blog_banner.jpg"} alt={"Banner.png"} />
        <div className="upvc_overlay">
          <div className="innerupvc_overlay">
            <div className="upvc_content">
              <Heading content={title} />
              {/* <div dangerouslySetInnerHTML={{ __html: content }} ></div> */}
              <p>{content}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="product_hero_section_footer">
        <div className="product_hero_footer">
          {subcategorylist.length === 0 ? (
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              {Array.from(new Array(4)).map((_, index) => (
                <Grid item xs={12} sm={6} md={3} lg={3} key={index}>
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      maxWidth: 300,
                      maxHeight: "100px",
                      minHeight: "100px",
                      mx: "auto",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            subcategorylist.map((items) => {
              return (
                <NavLink
                  to={
                    items.type === "Product"
                      ? `/${categoryslug}/${items.slug}`
                      : `/accessories/${items.slug}`
                  }
                >
                  <div className="accessories_container">
                    <div className="seting_icon_container">
                      <Img src={items.image} alt={"setting icon"} />
                    </div>
                    <div
                      dangerouslySetInnerHTML={{ __html: items.title }}
                    ></div>
                  </div>
                </NavLink>
              );
            })
          )}
        </div>
      </section>
    </>
  );
};
export { ProductCategoryHeroSection };
